import React from 'react'
import { Router } from '@reach/router'
import { BodyText, Container, Row, Col } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { Logger as clientLogger } from 'beaver-logger'
//utils
import { APP_URL } from './constants/constants'
import serverData from './utils/server-data'
import Layout from './components/Layout'
const Home = React.lazy(() => import('./screens/home'))
const logger = clientLogger({
  url: '/myaccount/privacy/log',
  logLevel: 'debug',
})

function App() {
  logger.info('CLIENT', { message: 'returning Privacy landing page' }) //client side logging
  const routeHome = APP_URL,
    { selectedComponent, isMerchantUser } = serverData,
    privacyHubclass =
      selectedComponent === 'privacyhub' ? 'app-privacyhub_home' : ''

  return (
    <Layout>
      <Container
        fluid={true}
        className={isMerchantUser && 'merchant-fluid-container'}
        data-testid="home-page"
      >
        <Row>
          <Col lg={12} className={privacyHubclass}>
            <React.Suspense
              fallback={
                <BodyText>
                  <Message id="app.suspense.fallbackText" />
                </BodyText>
              }
            >
              <Router basepath={serverData.requestURI}>
                <Home path="/privacyhub" />
                <Home path="/merchant" />
                <Home path={routeHome} />
                <Home path="/zettle/*" />
              </Router>
            </React.Suspense>
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export default App
